// extracted by mini-css-extract-plugin
export var sustainability = "sustainability-module--sustainability--GfQzs";
export var learnMoreCTA = "sustainability-module--learnMoreCTA--9j79B";
export var sustainableGif = "sustainability-module--sustainableGif--JMRxy";